import { BrowserRouter, Navigate, Route, Routes } from 'react-router';

import { ClearWorklistTasks } from 'components/admin/ClearWorklistTasks';
import { EditAuctionEnd } from 'components/admin/EditAuctionEnd';
import { AuthCallback } from 'components/auth/AuthCallback';
import { LoggedOut } from 'components/auth/LoggedOut';
import { RequireAuth } from 'components/auth/RequireAuth';
import { Batch } from 'components/batch/Batch';
import { TestClaim } from 'components/claim/TestClaim';
import { Home } from 'components/home/Home';
import { DeclareIncident } from 'components/incidentManagement/DeclareIncident';
import { IncidentDetails } from 'components/incidentManagement/IncidentDetails';
import { IncidentManagement } from 'components/incidentManagement/IncidentManagement';
import { ViewIncidents } from 'components/incidentManagement/ViewIncidents';
import { CreateMember } from 'components/member/CreateMember';
import { ViewMember } from 'components/member/ViewMember';
import { TestReferral } from 'components/referral/TestReferral';
import { ServiceBus } from 'components/serviceBus/ServiceBus';
import { RebillingTask } from 'components/worklist/RebillingTask';
import { WorklistTask } from 'components/worklist/WorklistTask';
import { AppRoutes } from 'services/routes';

export const App = () => {
    const routes = [
        {
            path: AppRoutes.home,
            main: <Home />,
        },
        {
            path: AppRoutes.createMember,
            main: <CreateMember />,
        },
        {
            path: AppRoutes.viewMember,
            main: <ViewMember />,
        },
        {
            path: AppRoutes.referral,
            main: <TestReferral />,
        },
        {
            path: AppRoutes.claim,
            main: <TestClaim />,
        },
        {
            path: AppRoutes.batch,
            main: <Batch />,
        },
        {
            path: AppRoutes.serviceBus,
            main: <ServiceBus />,
        },
        {
            path: AppRoutes.editAuctionEnd,
            main: <EditAuctionEnd />,
        },
        {
            path: AppRoutes.worklist,
            main: <WorklistTask />,
        },
        {
            path: AppRoutes.rebilling,
            main: <RebillingTask />,
        },
        {
            path: AppRoutes.clearTasks,
            main: <ClearWorklistTasks />,
        },
        {
            path: AppRoutes.incidentManagement,
            main: <IncidentManagement />,
        },
        {
            path: AppRoutes.declareIncident,
            main: <DeclareIncident />,
        },
        {
            path: AppRoutes.incidentDetails,
            main: <IncidentDetails />,
        },
        {
            path: AppRoutes.viewIncidents,
            main: <ViewIncidents />,
        },
    ];
    return (
        <BrowserRouter basename="/">
            <Routes>
                <Route path={AppRoutes.callback} element={<AuthCallback />} />
                <Route path={AppRoutes.loggedOut} element={<LoggedOut />} />
                <Route element={<RequireAuth />}>
                    {routes.map((route) => (
                        <Route key={route.path} path={route.path} element={route.main} />
                    ))}
                </Route>
                <Route path="*" element={<Navigate replace to={AppRoutes.home} />} />
            </Routes>
        </BrowserRouter>
    );
};
